import { Calendar } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import {
    formatFacilityDisplayDate,
    getDaysRemaining,
} from '../facilities/utils/utils';
import { useOnboarding } from '../../store/onboarding-context';

export default function TrialStatusBanner() {
    const { t } = useTranslation();
    const { department } = useOnboarding();

    if (!department?.start_date) return null;

    const goLiveDays = getDaysRemaining(department.start_date, 'go-live');
    const isTrial = department.isTrial !== false;

    return (
        <div className="border-b border-subtle bg-muted px-4 py-5 sm:px-6 lg:px-10">
            <div className="flex flex-wrap items-center justify-between gap-4">
                <div className="flex items-center gap-3">
                    <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-emerald-500/30 bg-emerald-500/10">
                        <Calendar
                            className="h-4 w-4 text-emerald-400"
                            aria-hidden="true"
                        />
                    </span>
                    <div>
                        <p className="text-sm font-medium text-foreground">
                            {t(
                                isTrial
                                    ? 'onboarding.trialStatusBanner.trialStarts'
                                    : 'onboarding.trialStatusBanner.goesLive',
                                {
                                    date: formatFacilityDisplayDate(department.start_date),
                                }
                            )}
                        </p>
                        {isTrial && department.end_date && (
                            <p className="mt-0.5 text-xs text-muted-foreground">
                                {t('onboarding.trialStatusBanner.ends', {
                                    date: formatFacilityDisplayDate(department.end_date),
                                })}
                            </p>
                        )}
                    </div>
                </div>
                {goLiveDays !== null && (
                    <span className="rounded-full border border-emerald-500/30 bg-emerald-500/10 px-3 py-1 text-xs font-medium text-emerald-400">
                        {t(
                            isTrial
                                ? 'onboarding.trialStatusBanner.daysUntilStart'
                                : 'onboarding.trialStatusBanner.daysUntilLaunch',
                            { days: goLiveDays }
                        )}
                    </span>
                )}
            </div>
        </div>
    );
}
